@import '../../../../style/src/typography/mixins';

:host {
	@include zds-typography('body');

	display: block;
}

.zds-stepper {
	display: flex;

	&--vertical {
		flex-direction: column;
	}
}

::slotted(zds-step) {
	flex: 1;
}

::slotted(zds-step::after) {
	content: 'Test';
}
